import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default function initSlider() {
  const array = document.querySelectorAll(".slider");

  if (array.length > 0) {
    array.forEach((element) => {
      new Swiper(element, {
        modules: [Navigation, Pagination],
        speed: 400,
        spaceBetween: 20,
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: element.querySelector(".swiper-button-next"),
          prevEl: element.querySelector(".swiper-button-prev"),
        },
        loop: false,
      });
    });
  }
};
